import { CorporateClients } from '@platform/client';
import { FormsInputDropdown, InputDropdownItem } from '@platform/components';
import { Control, FieldValues, Path } from 'react-hook-form';

type CorporateClientSelectionDropdownProps<FData extends FieldValues> = {
  selectionLimit?: number;
  control: Control<FData>;
  name: Path<FData>;
  label: string;
};

export const CorporateClientSelectionDropdown = <FData extends FieldValues>(
  props: CorporateClientSelectionDropdownProps<FData>,
) => {
  const corporateClients = CorporateClients.useGetAllCorporateClients().data || [];

  const corporateClientOptions: InputDropdownItem[] = corporateClients.map((client) => ({
    textValue: client.name,
    text: client.name,
  }));

  return (
    <FormsInputDropdown
      {...props}
      placeholder='Select one'
      items={corporateClientOptions}
      type='default'
    />
  );
};
